export const dict = {
  pt: {
    nav: { home: "Início", services: "Serviços", fleet: "Frota", heritage: "História", contact: "Contactos" },
    call: "Chamar Agora",
    hero_eyebrow: "Paços de Ferreira · Serviço de Táxi · 5.0 no Google",
    hero_lines: ["Mais de 50 anos", "de confiança", "em movimento."],
    hero_sub:
      "Frota 100% Mercedes-Benz ao serviço de empresas, seguradoras, escolas e particulares. Transfers de aeroporto, serviço ocasional e a simpatia de sempre — em Lamoso, Paços de Ferreira e para todo o país.",
    hero_cta_call: "Chamar Táxi · 914 014 369",
    hero_cta_whatsapp: "WhatsApp Direto",
    hero_scroll: "Deslize para descobrir",
    stat_years: "Anos de estrada",
    stat_cars: "Mercedes-Benz",
    stat_rating: "Avaliação Google",
    marquee: [
      "Transfers de Aeroporto",
      "Empresas da Região",
      "Seguradoras",
      "Transporte Escolar",
      "Serviço Ocasional",
      "MB Way · Apple Pay · Cartão",
      "Aposta em veículos elétricos",
      "Desde há mais de 50 anos",
    ],
    services_eyebrow: "O que fazemos",
    services_title: "Serviços para cada viagem",
    services_sub: "Da viagem do dia-a-dia ao transfer de madrugada — pontualidade, conforto e discrição em cada quilómetro.",
    services: [
      {
        id: "empresas",
        title: "Empresas da Região",
        desc: "Transporte executivo para colaboradores, clientes e convidados, com a fiabilidade que o seu negócio exige.",
      },
      {
        id: "seguradoras",
        title: "Seguradoras & Assistência",
        desc: "Mobilidade imediata em caso de sinistro ou avaria, em parceria com seguradoras e assistências em viagem.",
      },
      {
        id: "escolar",
        title: "Transporte Escolar",
        desc: "Percursos diários seguros e pontuais para crianças e estudantes, com motoristas de total confiança.",
      },
      {
        id: "ocasional",
        title: "Serviço Ocasional",
        desc: "Consultas, compras, deslocações pessoais ou simplesmente uma boleia cómoda — quando precisar.",
      },
      {
        id: "aeroporto",
        title: "Transfers de Aeroporto",
        desc: "Pick-ups e drop-offs ao Aeroporto Francisco Sá Carneiro (OPO) e outros, com marcação prévia e acompanhamento do voo.",
      },
    ],
    fleet_eyebrow: "A nossa frota",
    fleet_title: "Quatro Mercedes-Benz ao seu serviço",
    fleet_sub:
      "Uma frota 100% Mercedes-Benz, impecavelmente mantida — incluindo uma van espaçosa até 8 passageiros e a aposta na sustentabilidade, com veículos elétricos.",
    fleet_main_title: "A frota reunida",
    fleet_main_desc: "As quatro viaturas em Lamoso, prontas para partir.",
    fleet_suv_title: "Conforto executivo",
    fleet_suv_desc: "Interiores cuidados, ar condicionado e condução serena.",
    fleet_chip_brand: "100% Mercedes-Benz",
    fleet_chip_van: "Van até 8 passageiros",
    fleet_chip_electric: "Veículos elétricos",
    fleet_chip_luggage: "Bagagem XL",
    fleet_chip_ac: "Ar Condicionado",
    heritage_eyebrow: "A nossa história",
    heritage_title: "Meio século ao volante em Paços de Ferreira",
    heritage_p1:
      "Os Táxis Leão & Henrique nasceram em Lamoso há mais de 50 anos e cresceram com a região. Gerações de clientes confiam em nós para as viagens que importam — da primeira comunhão ao voo de madrugada.",
    heritage_p2:
      "Hoje, a frota é moderna, 100% Mercedes-Benz e aposta em veículos elétricos — mas os valores são os de sempre: pontualidade, segurança e um trato próximo, de vizinho.",
    heritage_badge_years: "Anos de experiência",
    heritage_badge_rating: "no Google",
    heritage_badge_fleet: "Frota 100% Mercedes-Benz",
    payments_eyebrow: "Pagamento fácil",
    payments_title: "Pague como preferir",
    payments_sub: "Sem complicações no final da viagem.",
    pay_card: "Cartão de Crédito / Débito",
    pay_card_desc: "Terminal a bordo — Visa, Mastercard e Multibanco.",
    pay_apple: "Apple Pay",
    pay_apple_desc: "Pagamento contactless rápido e seguro.",
    pay_mbway: "MB Way",
    pay_mbway_desc: "Transferência instantânea pelo telemóvel.",
    contact_eyebrow: "Contactos",
    contact_title: "Precisa de um táxi?",
    contact_sub: "Ligue, envie WhatsApp ou e-mail — respondemos com a rapidez de quem está sempre na estrada.",
    contact_call_label: "Chamada direta",
    contact_whatsapp_label: "Mensagem instantânea",
    contact_email_label: "Escreva-nos",
    contact_address_title: "A nossa sede",
    contact_address: "Rua do Comércio, 106 · Lamoso · 4590-410 Paços de Ferreira",
    contact_maps: "Abrir no Google Maps",
    footer_tagline: "Táxis Leão & Henrique — Paços de Ferreira, há mais de 50 anos ao seu serviço.",
    footer_rights: "Todos os direitos reservados.",
  },
  en: {
    nav: { home: "Home", services: "Services", fleet: "Fleet", heritage: "Heritage", contact: "Contact" },
    call: "Call Now",
    hero_eyebrow: "Paços de Ferreira · Taxi Service · 5.0 on Google",
    hero_lines: ["Over 50 years", "of trusted", "journeys."],
    hero_sub:
      "A 100% Mercedes-Benz fleet serving businesses, insurers, schools and private clients. Airport transfers, occasional rides and the warm service of always — in Lamoso, Paços de Ferreira and beyond.",
    hero_cta_call: "Call a Taxi · +351 914 014 369",
    hero_cta_whatsapp: "Direct WhatsApp",
    hero_scroll: "Scroll to explore",
    stat_years: "Years on the road",
    stat_cars: "Mercedes-Benz",
    stat_rating: "Google rating",
    marquee: [
      "Airport Transfers",
      "Local Businesses",
      "Insurance Partners",
      "School Transport",
      "Occasional Rides",
      "MB Way · Apple Pay · Cards",
      "Committed to electric vehicles",
      "Over 50 years on the road",
    ],
    services_eyebrow: "What we do",
    services_title: "Services for every journey",
    services_sub: "From the daily commute to the dawn airport run — punctuality, comfort and discretion on every kilometre.",
    services: [
      {
        id: "empresas",
        title: "Local Businesses",
        desc: "Executive transport for staff, clients and guests, with the reliability your business demands.",
      },
      {
        id: "seguradoras",
        title: "Insurance & Assistance",
        desc: "Immediate mobility in case of accident or breakdown, partnering with insurers and roadside assistance.",
      },
      {
        id: "escolar",
        title: "School Transport",
        desc: "Safe, punctual daily rides for children and students, with fully trusted drivers.",
      },
      {
        id: "ocasional",
        title: "Occasional Rides",
        desc: "Appointments, errands, private journeys or simply a comfortable lift — whenever you need it.",
      },
      {
        id: "aeroporto",
        title: "Airport Transfers",
        desc: "Pick-ups and drop-offs at Porto Airport (OPO) and beyond, with advance booking and flight tracking.",
      },
    ],
    fleet_eyebrow: "Our fleet",
    fleet_title: "Four Mercedes-Benz at your service",
    fleet_sub:
      "A 100% Mercedes-Benz fleet, immaculately maintained — including a spacious van for up to 8 passengers and a commitment to sustainability, with electric vehicles.",
    fleet_main_title: "The fleet, together",
    fleet_main_desc: "All four vehicles in Lamoso, ready to roll.",
    fleet_suv_title: "Executive comfort",
    fleet_suv_desc: "Pristine interiors, climate control and a smooth, calm ride.",
    fleet_chip_brand: "100% Mercedes-Benz",
    fleet_chip_van: "Van up to 8 passengers",
    fleet_chip_electric: "Electric vehicles",
    fleet_chip_luggage: "XL luggage",
    fleet_chip_ac: "Air conditioning",
    heritage_eyebrow: "Our heritage",
    heritage_title: "Half a century behind the wheel in Paços de Ferreira",
    heritage_p1:
      "Táxis Leão & Henrique was born in Lamoso over 50 years ago and grew up alongside the region. Generations of clients trust us with the journeys that matter — from the first communion to the dawn flight.",
    heritage_p2:
      "Today the fleet is modern, 100% Mercedes-Benz and investing in electric vehicles — but the values are unchanged: punctuality, safety and the warm, neighbourly care of always.",
    heritage_badge_years: "Years of experience",
    heritage_badge_rating: "on Google",
    heritage_badge_fleet: "100% Mercedes-Benz fleet",
    payments_eyebrow: "Easy payment",
    payments_title: "Pay the way you prefer",
    payments_sub: "No hassle at the end of the ride.",
    pay_card: "Credit / Debit Card",
    pay_card_desc: "On-board terminal — Visa, Mastercard and Multibanco.",
    pay_apple: "Apple Pay",
    pay_apple_desc: "Fast, secure contactless payment.",
    pay_mbway: "MB Way",
    pay_mbway_desc: "Instant transfer from your phone.",
    contact_eyebrow: "Contact",
    contact_title: "Need a taxi?",
    contact_sub: "Call, WhatsApp or email us — we answer with the speed of someone always on the road.",
    contact_call_label: "Direct call",
    contact_whatsapp_label: "Instant message",
    contact_email_label: "Write to us",
    contact_address_title: "Our headquarters",
    contact_address: "Rua do Comércio, 106 · Lamoso · 4590-410 Paços de Ferreira",
    contact_maps: "Open in Google Maps",
    footer_tagline: "Táxis Leão & Henrique — Paços de Ferreira, serving you for over 50 years.",
    footer_rights: "All rights reserved.",
  },
};

export const LINKS = {
  phone: "tel:+351914014369",
  phoneDisplay: "914 014 369",
  phoneIntl: "+351 914 014 369",
  phone2: "tel:+351918079004",
  phone2Display: "918 079 004",
  phone2Intl: "+351 918 079 004",
  whatsapp:
    "https://wa.me/351914014369?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20t%C3%A1xi.",
  email: "mailto:coelhoeirmalda@gmail.com",
  emailDisplay: "coelhoeirmalda@gmail.com",
  maps: "https://www.google.com/maps/search/?api=1&query=Rua+do+Com%C3%A9rcio+106%2C+Lamoso%2C+4590-410+Pa%C3%A7os+de+Ferreira",
};
